module.exports = __webpack_public_path__ + "media/video-open8_finalized.8499ad87.mp4";